module.exports = __webpack_public_path__ + "img/portada2.9fa6723d.png";